import { orderBy } from 'lodash';

function PaymentModes(data) {
    this.payModes = this.createPayModes(data);
}

PaymentModes.prototype = Object.assign(PaymentModes.prototype, {
    createPayModes(data) {
        const netbanking = data.filter(mode => mode.paymentType === 'NB' && mode.subModeNameUI);
        const creditCards = data.filter(mode => mode.paymentType === 'CC');
        const debitCards = data.filter(mode => mode.paymentType === 'DC');
        const upi = data.filter(mode => mode.paymentType === 'UPI');
        const wallets = data.filter(mode => mode.paymentType === 'WALLET');
        const accountVerification = data.filter(
            mode => mode.paymentType === 'ACCOUNT_VERIFICATION'
        );
        const emi = data.filter(
            mode => mode.paymentType === 'EMI_CC' && mode.subMode === 'CCEMI'
        );

        const debitCardBusinessSource = debitCards
            ? this.getBusinessSources(debitCards)
            : [];

        const emiBusinessSource = emi ? this.getBusinessSources(emi) : [];

        const creditCardBusinessSource = creditCards
            ? this.getBusinessSources(creditCards)
            : [];

        const upiBusinessSource = upi ? this.getBusinessSources(upi) : [];

        const upiAccountType =
            upi && upi.length > 0 && upi[0].txnConfig
                ? this.getBusinessSourcesToAccountTypeMapping(upi[0].txnConfig)
                : [];
        
        return {
            netbanking: this.sortOptions(netbanking),
            creditCards: this.sortOptions(creditCards),
            debitCards: this.sortOptions(debitCards),
            upi: this.sortOptions(upi),
            debitCardBusinessSource,
            creditCardBusinessSource,
            upiBusinessSource,
            upiAccountType,
            emiBusinessSource,
            wallets: this.sortOptions(wallets),
            accountVerification: this.sortOptions(accountVerification),
            emi: this.sortOptions(emi),
        };
    },
    getBusinessSourcesToAccountTypeMapping(txnConfig) {
        const txnConfigObj = {};

        for (const txn of txnConfig) {
            const businessSource = txn.businessSource;
            const accountTypes = txn.accountType.filter(type => type !== null);

            if (businessSource !== null && accountTypes.length > 0) {
                if (!txnConfigObj[businessSource]) {
                    txnConfigObj[businessSource] = [];
                }

                txnConfigObj[businessSource].push(...accountTypes);
            }
        }
        return txnConfigObj;
    },
    getBusinessSources(paymentTypeArray) {
        return paymentTypeArray.length > 0 &&
            paymentTypeArray[0] &&
            paymentTypeArray[0].txnConfig
            ? paymentTypeArray[0].txnConfig
                  .filter(config => config.businessSource)
                  .map(config => config.businessSource)
            : [];
    },
    sortOptions(data) {
        if (data && data.length) {
            return orderBy(data, ['subModeNameUI'], ['asc']);
        }
        return data;
    },
});

export default PaymentModes;
